import React from "react";
import * as styles from "./rules-editor-card.module.scss";

export interface RulesEditorCardProps {
	icon: React.ReactNode;
	title: string;
	children?: React.ReactNode;
}

/**
 * A major card in the rules editor, containing a title and an icon.
 */
export default function RulesEditorCard(props: RulesEditorCardProps) {
	return (
		<div className={styles.card}>
			<div className={styles.toolbar}>
				{props.icon}
				<span className={styles.title}>{props.title}</span>
			</div>

			{props.children}
		</div>
	);
}
